<template>
  <div class="closable-header">
    <div class="text">
      <slot />
    </div>
    <Button
      color="white"
      :icon-btn="true"
      class="text-white"
      large
      variant="outlined"
      @click="$emit('close')"
    >
      <v-icon color="white">
        mdi-close
      </v-icon>
    </Button>
  </div>
</template>

<script setup lang="ts">
import Button from "@/components/input-components/Button.vue";

defineOptions({ name: "ClosableHeader" });

const emit = defineEmits(['close']);

</script>

<style lang="scss">
.closable-header {
  background: rgb(var(--v-theme-blue));
  min-height: 6rem;
  width: 100%;
  max-width: 100vw;
  display: flex;
  align-items: center;
  padding: .9375rem;
  box-sizing: border-box;
  .text {
    color: rgb(var(--v-theme-white));
    font-weight: 400;
    font-size: 1.25rem;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
